// src/components/DateFilters.js

import { useEffect, useRef } from "react";
import DatePicker from "react-datepicker";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";

const DateFilters = ({ fetchData, perPage, page, depositDates, setDepositDates }) => {
	const startDepositDatePickerRef = useRef(null);
	const endDepositDatePickerRef = useRef(null);

	const handleDepositDateFieldClick = (pickerRef) => {
		if (pickerRef.current) {
			pickerRef.current.setOpen(true);
		}
	}

	// Refetch the invoices if the deposit dates field change
	useEffect(() => {
		if (depositDates.start || depositDates.end) fetchData(perPage, page, depositDates);		
	}, [depositDates]);

	return (
		<div className="mb-4">
			<h2 className="sidebar:text-base font-semibold">Période de dépôt</h2>
			<div className="flex justify-between w-[9.3rem] sidebar:w-[17.5rem] mt-[1.5rem] sidebar:mt-[0.9rem] periode-aff">
				<div className="px-[0.9rem] flex justify-center w-[48%] rounded-lg border h-[2.3rem] sidebar:py-1 sidebar:h-[2.7rem] items-center">
					<div className="flex text-xs items-center dates-filtre font-bold relative w-full">
						<span className="uppercase mr-1">Du</span>
						<DatePicker
							selected={depositDates.start}
							showMonthDropdown
							showYearDropdown
							onChange={(date) => setDepositDates((prev) => ({ ...prev, start: date }))}
							className="bg-none-input custom-calendar text-xs w-full pr-[0.5rem]" 
							dateFormat="dd/MM/yyyy"
							minDate={new Date('1990-01-01')}
							maxDate={new Date('2300-01-01')}
							ref={startDepositDatePickerRef}
						/>
						<ArrowDropDownIcon
							className="custom-calendar-icon absolute right-0 top-1/2 transform -translate-y-1/2 cursor-pointer text-gray-500"
							onClick={() => handleDepositDateFieldClick(startDepositDatePickerRef)}
						/>
					</div>
				</div>
				<div className="px-[0.9rem] flex justify-center w-[48%] rounded-lg border h-[2.3rem] sidebar:py-1 sidebar:h-[2.7rem] items-center">
					<div className="flex text-xs items-center dates-filtre font-bold relative w-full">
						<span className="uppercase mr-1">Au</span>
						<DatePicker
							id="input-period-to"
							selected={depositDates.end}
							showMonthDropdown
							showYearDropdown
							onChange={(date) => setDepositDates((prev) => ({ ...prev, end: date }))}
							className="bg-none-input custom-calendar text-xs w-full pr-[0.5rem]"
							dateFormat="dd/MM/yyyy"
							minDate={new Date('1990-01-01')}
							maxDate={new Date('2300-12-31')}
							ref={endDepositDatePickerRef}
						/>
						<ArrowDropDownIcon
							className="custom-calendar-icon absolute right-0 top-1/2 transform -translate-y-1/2 cursor-pointer text-gray-500"
							onClick={() => handleDepositDateFieldClick(endDepositDatePickerRef)}
						/>
					</div>
				</div>
			</div>
		</div>
	)
}

export default DateFilters;
